import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() { return [ "label" ] }
  
  fileChanged(e) {
    this.labelTarget.innerHTML = e.target.files[0].name
  }
}
